//@ts-check
import React from 'react';
import Text from './Text';
var domainRegExp = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;

var DomainField = function DomainField(props) {
  return React.createElement(Text, Object.assign({
    type: "text",
    validate: function validate(value) {
      if (value === undefined) {
        return props.required ? 'Domain is required' : undefined;
      } else {
        return domainRegExp.test(value) ? undefined : 'Domain address is invalid';
      }
    }
  }, props));
};

export default DomainField;